import { render, staticRenderFns } from "./BlockListRteSharedCustom.vue?vue&type=template&id=8364fa50&"
import script from "./BlockListRteSharedCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListRteSharedCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports